import { useStore } from 'effector-react'

import {
  $totalCountOfUserGroups,
  getUserGroups,
  $userGroups,
  groupsListMounted,
} from './model'
import { UserGroupsRequest } from './types'

export const useGroupsList = () => {
  const userGroups = useStore($userGroups)
  const loading = useStore(getUserGroups.pending)
  const totalCountOfUserGroups = useStore($totalCountOfUserGroups)

  const onChangeGroupList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: UserGroupsRequest) => {
    groupsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    userGroups,
    totalCountOfUserGroups,
    loading,
    onChangeGroupList,
  }
}
